import { createFileRoute } from "@tanstack/react-router";
import { getIspmHostConfig } from "../../config/ispmHostConfig";
import { MfeLoader } from "../../mfe/MfeLoader";

export const Route = createFileRoute("/identities/$")({
  component: IspmIdentitiesPage,
});

function IspmIdentitiesPage() {
  return (
    <MfeLoader name="ispm-ui" props={{ hostConfig: getIspmHostConfig() }} />
  );
}
